import { z } from 'zod';

export type LeadErrorMessages = {
  nameMax: string;
  companyMax: string;
  painMin: string;
  painMax: string;
  contactMin: string;
  contactInvalid: string;
  consent: string;
};

const TELEGRAM = /^@[A-Za-z0-9_]{3,}$/;
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE = /^\+?[\d\s\-()]{7,20}$/;

export function createLeadSchema(m: LeadErrorMessages) {
  return z.object({
    name: z.string().max(50, m.nameMax).optional(),
    company: z.string().max(100, m.companyMax).optional(),
    budget: z.enum(['<500K', '500K-1M', '1M-3M', '3M+', 'undefined']).optional(),
    pain: z.string().min(20, m.painMin).max(2000, m.painMax),
    contact: z
      .string()
      .min(3, m.contactMin)
      .refine(
        (v) => TELEGRAM.test(v) || EMAIL.test(v) || PHONE.test(v),
        m.contactInvalid,
      ),
    consent: z.literal(true, { error: m.consent }),
  });
}

/**
 * Серверная валидация: тексты ошибок наружу не отдаются, клиент показывает свои.
 * `locale` приходит только с клиента — в форме этого поля нет.
 */
export const leadSchema = createLeadSchema({
  nameMax: 'name too long',
  companyMax: 'company too long',
  painMin: 'pain too short',
  painMax: 'pain too long',
  contactMin: 'contact too short',
  contactInvalid: 'contact invalid',
  consent: 'consent required',
}).extend({
  locale: z.enum(['ru', 'en']).default('ru'),
});

export type LeadInput = z.infer<ReturnType<typeof createLeadSchema>>;
